// log-pile for the browser: window errors and unhandled rejections become
// captures, every API call leaves a breadcrumb (api/index.ts, logger.ts), and
// the signed-in user is attached (providers/authProvider.tsx). Sent as
// beacons to log-pile's /ingest with this site's public key; without a key
// (e.g. a fresh .env.local) captures print to the console instead.
import {
  beaconTransport,
  consoleTransport,
  createLogPile,
  installBrowserHandlers,
} from "../../shared-utils/logPile";
import packageJSON from "../package.json";

const url = import.meta.env.VITE_LOG_PILE_URL;
const key = import.meta.env.VITE_LOG_PILE_KEY;
const mode =
  import.meta.env.VITE_LOG_PILE_TRANSPORT === "fetch" ? "fetch" : "beacon";

export const logPile = createLogPile({
  source: "doridium-website",
  runtime: "browser",
  env: import.meta.env.VITE_STAGE || "local",
  release: packageJSON.version,
  transport:
    url && key
      ? beaconTransport({ url: `${url}/ingest`, key, mode })
      : consoleTransport(),
});

installBrowserHandlers(logPile);
logPile.reset({ location: window.location.href });
